import {
  API_ERROR,
  SERVICEREQUEST_PENDING_LIST,
  SERVICEREQUEST_PENDING_LIST_SUCCESS,
  // MATERIALREQUEST_ROW_LIST,
  // MATERIALREQUEST_ROW_LIST_SUCCESS,
  SR_MODEL_LIST_OPEN,
  SR_MODEL_LIST_CLOSE,
  ALL_SR_ITEMS_CHECKED,
  SR_ITEMS_CHECKED,
  SR_SELECT_ITEM,
  PI_SELECTED_ITEM,
  ADD_TO_SELECTED_ITEM,
  MY_SR_PURCHASEINDENT_LIST,
  SR_PURCHASEINDENT_LIST,
  MY_SR_PURCHASEINDENT_LIST_SUCCESS,
  MY_SR_PI_LIST_COUNT,
  SR_PI_LIST_COUNT,
  SR_PI_LIST_COUNT_SUCCESS,
  SET_PARAMS_SR,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SELECT_CHANGEVALUE,
  SR_PURCHASEINDENT_ROW,
  SR_PURCHASEINDENT_ROW_SUCCESS,
  SI_INPUT_CHANGEVALUE,
  SI_SELECT_CHANGEVALUE,
  REMOVE_SELECTED_PRODUCT,
  SR_PURCHASEINDENT_ADD,
  PI_ITEM_HOD_APPROVAL,
  // PII_DEPT_HOD_APPROVAL,
  PI_ROW_LOADING,
  SR_PI_HOD_APPROVE_ADD,
  PI_SR_PRODUCTS_REQUEST_LIST,
  PI_SR_PRODUCTS_REQUEST_LIST_SUCCESS,
  PRODUCTS_ROW_REQUEST,
  PRODUCTS_ROW_REQUEST_SUCCESS,
  PRODUCT_MODEL_CLOSE,
  PRODUCT_MODEL_OPEN,
  SR_PURCHASEINDENT_DELETE,
  TOGGLE_ITEM_MENU,
  LIST_LAYOUT,
  SR_PI_MODEL_LIST_OPEN,
  SR_PI_MODEL_LIST_CLOSE,
  PI_FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  PRODUCT_STORE_QTY,
  PRODUCT_STORE_QTY_SUCCESSFUL,
  SR_DETAILS_MODEL_OPEN,
  SR_DETAILS_MODEL_CLOSE,
  SERVICEREQUEST_ROW_DATA_SUCCESS,
  PI_SR_ITEM_IMAGES,
  PI_SR_ITEM_IMAGES_SUCCESS,
  PRODUCT_ITEM_HISTORY_MODEL_OPEN,
  PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
  SR_FILTERS_SHOW_RIGHT_SIDEBAR,
} from "./actionTypes";
export const getSRList = (data) => {
  return {
    type: SERVICEREQUEST_PENDING_LIST,
    payload: { data },
  };
};
export const MRListSuccessful = (response) => {
  return {
    type: SERVICEREQUEST_PENDING_LIST_SUCCESS,
    payload: response,
  };
};
export const AllMRItemsChecked = (checked) => {
  return {
    type: ALL_SR_ITEMS_CHECKED,
    payload: { checked },
  };
};
export const MRItemsChecked = (checked, item, index) => {
  return {
    type: SR_ITEMS_CHECKED,
    payload: { checked, item, index },
  };
};
export const getMRSelectItem = (checked, id, PISelectItem) => {
  return {
    type: SR_SELECT_ITEM,
    payload: { checked, id, PISelectItem },
  };
};
export const PISelectedItems = (checked, item) => {
  return {
    type: PI_SELECTED_ITEM,
    payload: { checked, item },
  };
};
export const AddToSelectedItems = (item) => {
  return {
    type: ADD_TO_SELECTED_ITEM,
    payload: { item },
  };
};
export const getProductStoreQty = (ProductID) => {
  return {
    type: PRODUCT_STORE_QTY,
    payload: { ProductID },
  };
};
export const getProductStoreQtySuccessful = (payload) => {
  return {
    type: PRODUCT_STORE_QTY_SUCCESSFUL,
    payload: payload,
  };
};
//----------------------------------------------
// export const getMRRowList = (data) => {
//   return {
//     type: MATERIALREQUEST_ROW_LIST,
//     payload: { data },
//   };
// };
// export const getMRRowListSuccessful = (responsedata) => {
//   return {
//     type: MATERIALREQUEST_ROW_LIST_SUCCESS,
//     payload: responsedata,
//   };
// };
export const MR_model_open = () => {
  return {
    type: SR_MODEL_LIST_OPEN,
  };
};

export const MR_model_close = () => {
  return {
    type: SR_MODEL_LIST_CLOSE,
  };
};

export const getMySR_PIReqList = (data) => {
  return {
    type: MY_SR_PURCHASEINDENT_LIST,
    payload: { data },
  };
};
export const getPIReqList = (data) => {
  return {
    type: SR_PURCHASEINDENT_LIST,
    payload: { data },
  };
};
export const MySRPIListSuccessful = (response) => {
  return {
    type: MY_SR_PURCHASEINDENT_LIST_SUCCESS,
    payload: response,
  };
};
export const getMySR_PIListcount = (data) => {
  return {
    type: MY_SR_PI_LIST_COUNT,
    payload: { data },
  };
};
export const getPIListcount = (data) => {
  return {
    type: SR_PI_LIST_COUNT,
    payload: { data },
  };
};
export const PIListCountSuccessful = (request) => {
  return {
    type: SR_PI_LIST_COUNT_SUCCESS,
    payload: request,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS_SR,
    payload: params,
  };
};
export const FilterChangeValue = ({ key, value }) => {
  return {
    type: FILTER_INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};
export const FilterSelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: FILTER_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const modelListOpen = (PIId) => {
  return {
    type: SR_PI_MODEL_LIST_OPEN,
    payload: { PIId },
  };
};

export const modelListClose = () => {
  return {
    type: SR_PI_MODEL_LIST_CLOSE,
  };
};
export const getPIReqestRowDetails = (PIId) => {
  return {
    type: SR_PURCHASEINDENT_ROW,
    payload: { PIId },
  };
};

export const pintRequestsuccessfull = (response) => {
  return {
    type: SR_PURCHASEINDENT_ROW_SUCCESS,
    payload: response,
  };
};
export const getPIAllProducts = (data, clearList) => {
  return {
    type: PI_SR_PRODUCTS_REQUEST_LIST,
    payload: { data, clearList },
  };
};
export const productstListSuccessful = (request) => {
  return {
    type: PI_SR_PRODUCTS_REQUEST_LIST_SUCCESS,
    payload: request,
  };
};
export const getRowProducts = (id) => {
  return {
    type: PRODUCTS_ROW_REQUEST,
    payload: { id },
  };
};
export const productRowSuccessful = (request) => {
  return {
    type: PRODUCTS_ROW_REQUEST_SUCCESS,
    payload: request,
  };
};
export const SIInputChangeValue = ({ key, value, item }) => {
  return {
    type: SI_INPUT_CHANGEVALUE,
    payload: { key, value, item },
  };
};
export const SISelecteChangeValue = ({ key, label, key2, value, item }) => {
  return {
    type: SI_SELECT_CHANGEVALUE,
    payload: { key, label, key2, value, item },
  };
};
export const removeSelectProducts = (data) => {
  return {
    type: REMOVE_SELECTED_PRODUCT,
    payload: data,
  };
};
export const addPurchaseIndent = (data, PIId, history) => {
  return {
    type: SR_PURCHASEINDENT_ADD,
    payload: { data, PIId, history },
  };
};
// export const PIDepItemapprove = (data) => {
//   return {
//     type: PII_DEPT_HOD_APPROVAL,
//     payload: { data },
//   };
// };
export const PIitemHodApproval = (data, history) => {
  return {
    type: PI_ITEM_HOD_APPROVAL,
    payload: { data, history },
  };
};
export const PIHodApprovedRequest = (data, history) => {
  return {
    type: SR_PI_HOD_APPROVE_ADD,
    payload: { data, history },
  };
};
export const PIRowloading = (data) => {
  return {
    type: PI_ROW_LOADING,
    payload: data,
  };
};
export const productModel_open = () => {
  return {
    type: PRODUCT_MODEL_OPEN,
  };
};

export const productModel_close = () => {
  return {
    type: PRODUCT_MODEL_CLOSE,
  };
};

export const SRDetailsModel_open = (MRID) => {
  return {
    type: SR_DETAILS_MODEL_OPEN,
    payload: { MRID },
  };
};

export const SRDetailsModel_close = () => {
  return {
    type: SR_DETAILS_MODEL_CLOSE,
  };
};

export const MRRowDataSuccessful = (response) => {
  return {
    type: SERVICEREQUEST_ROW_DATA_SUCCESS,
    payload: response,
  };
};
export const purIntRequestDelete = (PIid, history) => {
  return {
    type: SR_PURCHASEINDENT_DELETE,
    payload: { PIid, history },
  };
};
export const toggleItemMenu = (id) => {
  return {
    type: TOGGLE_ITEM_MENU,
    payload: id,
  };
};
export const listlayout = (layout) => {
  return {
    type: LIST_LAYOUT,
    payload: layout,
  };
};
export const FiltersShowRightSidebar = (PIFilterlevel) => {
  return {
    type: SR_FILTERS_SHOW_RIGHT_SIDEBAR,
    payload: { PIFilterlevel },
  };
};
export const FiltershideRightSidebar = () => ({
  type: FILTERS_HIDE_RIGHT_SIDEBAR,
  payload: null,
});
export const FilterClear = () => {
  return {
    type: CLEAR_FILTER,
    payload: null,
  };
};
export const getMrItemImages = (PIItemID, mrItemId) => {
  return {
    type: PI_SR_ITEM_IMAGES,
    payload: { PIItemID, mrItemId },
  };
};
export const getMrItemImageSuccess = (response) => {
  return {
    type: PI_SR_ITEM_IMAGES_SUCCESS,
    payload: response,
  };
};
export const productItemHistoryModelOpen = (data) => {
  return {
    type: PRODUCT_ITEM_HISTORY_MODEL_OPEN,
    payload: { data },
  };
};
export const productItemHistoryModelClose = () => {
  return {
    type: PRODUCT_ITEM_HISTORY_MODEL_CLOSE,
    // payload: { item },
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
